<div class="range-limits">
  <div
    class="range-initial"
    [ngStyle]="{
      'width.%': rangeContent * tick
    }"
  >
    <ion-button
      id="confetti-button"
      class="mpe-button-icon-circle ion-no-padding tick-cart confetti-button"
      size="default"
      mode="ios"
      shape="round"
      color="correct"
      disabled
      [ngStyle]="{
        left: 'calc(' + positionCart + '% - 11px)',
        transition: !isIOS ? 'all 300ms linear' : 'unset'
      }"
    >
      <div class="overlay"></div>
      <ion-icon
        slot="icon-only"
        [src]="'Icons.cart-outline-white' | translate"
      ></ion-icon>
    </ion-button>

    <div class="minimum radius-l" [ngStyle]="{ 'width.%': rangeMin }"></div>

    <div
      class="content"
      [ngClass]="{ 'radius-r': rangeMax < 1, 'radius-l': minimum < 1 }"
      [ngStyle]="{
        'width.%': (rangeContent - minimum) * tick
      }"
    ></div>
  </div>

  <div
    class="maximum radius-r"
    [ngStyle]="{ width: 'calc(' + rangeMax + '% - 3px)' }"
  ></div>
</div>
